export default "__VITE_ASSET__BnHFXxgl__"